import React, { useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { FormattedMessage } from 'react-intl'
import classnames from 'classnames'
import { METADATA_SCOPES } from '../../../constants/marketRecords'
import {
  MarketPanelToggledAll,
  MarketPanelToggledQuartile,
} from '../../../constants/trackingEvents'
import { dispatchEvent } from '../../../helpers/tagManager'
import { setMarketRecordsMetadataScope } from '../../../actions/marketRecords'
import { selectHomeValue } from '../../../store/selectors/home/metadata'
import {
  selectCurrentDataRepresentsMutliFamily,
  selectCurrentDataRepresentsQuartile,
} from '../../../store/selectors/marketRecord'
import { If, Unless, CheckBoxPill, Format } from '../..'
import { IconHome } from '../Icon'
import OverlayDefaultHeader from '../Routing/Headers/OverlayDefaultHeader'

import styles from './MarketSpotlightHeader.module.scss'

const MarketSpotlight = ({ ...restProps }) => {
  const dispatch = useDispatch()

  const pricedAround = useSelector(selectHomeValue)
  const forMultiFamily = useSelector(selectCurrentDataRepresentsMutliFamily)
  const defaultQuartile = useSelector(selectCurrentDataRepresentsQuartile)

  const [useQuartile, setUseQuartile] = useState(defaultQuartile)
  const toggleChecks = e => {
    if (e.target.checked) {
      const newUseQuartile = !useQuartile

      dispatchEvent(
        newUseQuartile ? MarketPanelToggledQuartile : MarketPanelToggledAll
      )
      dispatch(
        setMarketRecordsMetadataScope(
          newUseQuartile ? METADATA_SCOPES.QUARTILE : METADATA_SCOPES.COMPOSITE
        )
      )
      setUseQuartile(newUseQuartile)
    }
  }

  return (
    <OverlayDefaultHeader {...restProps} className={styles.root}>
      <div className={styles.choiceWrap}>
        <CheckBoxPill
          dataQa='all-homes-btn'
          name='all'
          className={classnames(
            styles.pill,
            !useQuartile && styles.highlighted
          )}
          iconStart={() => (
            <span className={styles.doubleHome}>
              <IconHome />
              <IconHome />
            </span>
          )}
          checked={!useQuartile}
          onClick={toggleChecks}
        >
          <Unless condition={forMultiFamily}>
            <FormattedMessage
              id='MarketSpotlight.header.allCheck.single'
              defaultMessage='All homes'
            />
          </Unless>
          <If condition={forMultiFamily}>
            <FormattedMessage
              id='MarketSpotlight.header.allCheck.multi'
              defaultMessage='All condos'
            />
          </If>
        </CheckBoxPill>
        <CheckBoxPill
          dataQa='priced-around-btn'
          name='quartile'
          className={classnames(styles.pill, useQuartile && styles.highlighted)}
          iconStart={IconHome}
          checked={useQuartile}
          onClick={toggleChecks}
        >
          <FormattedMessage
            id='MarketSpotlight.header.quartileCheck'
            defaultMessage='Priced around {price}'
            values={{
              price: <Format.Currency abbreviate value={pricedAround} />,
            }}
          />
        </CheckBoxPill>
      </div>
    </OverlayDefaultHeader>
  )
}

export default MarketSpotlight
